/*
 * Copyright (c) GeoMobile GmbH, 2022
 */
import { defaultAuthState } from './auth/Auth.state';
export var defaultAppState = {
    authState: defaultAuthState,
};
